/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your username`)
};

const zh_hans1_login_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的用户名`)
};

const zh_hant1_login_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入您的使用者名稱`)
};

const fr_login_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez votre nom d’utilisateur`)
};

const de_login_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzernamen eingeben`)
};

const ja_login_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名を入力`)
};

const ko_login_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 이름을 입력하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_username_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_username_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_username_placeholder", locale)
	if (locale === "en") return en_login_username_placeholder(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_username_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_username_placeholder(inputs)
	if (locale === "fr") return fr_login_username_placeholder(inputs)
	if (locale === "de") return de_login_username_placeholder(inputs)
	if (locale === "ja") return ja_login_username_placeholder(inputs)
	return ko_login_username_placeholder(inputs)
};